import React, { useEffect } from "react";
import { connect } from "react-redux";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DlUnit from "../../models/DlUnit";
import DlUnitCat from "./DlUnitCat.js";
import DlUnitEl from "../adm/DlUnitEl";
import DlUnitLiNav from "../adm/DlUnitLiNav";
import { getUnitLi, getGroupUtypeUnitLi, getUnitLiPage } from "../../actions";
import { sidemenuFooterWrap } from "../componentCommon";
import { dlGroupGet, condUTypeGet } from "../../selectors";
import DlUnitSearch from '../adm/DlUnitSearch';

//import "../../index.scss";

const mapStateToProps = state => ({
  dlUnitN: state.dlUnitLi.dlUnitN,
  dlUnitCount: state.dlUnitLi.dlUnitCount,
  dlGroup: dlGroupGet(state)
});

const mapDispatchToProps = dispatch => ({
  getGroupUtypeUnitLi: payload => dispatch(getGroupUtypeUnitLi(payload)),
  getUnitLi: payload => dispatch(getUnitLi(payload)),
  getUnitLiPage: payload => dispatch(getUnitLiPage(payload))  
});

const BooksListing = ({ match, dlUnitN, dlUnitCount, dlUnitMaxPerPage, dlGroup, getUnitLi, getGroupUtypeUnitLi, getUnitLiPage }) => {
  // console.log(match);
  let groupSlug = '', uType = '';
  // let pageNum = 1, pageNumCh = false;
  if (match.path.indexOf('/hemeroteka') == -1) {
    groupSlug = "groupSlug" in match.params ? match.params.groupSlug : "";
    uType = "uType" in match.params ? match.params.uType : "";      
  } else {
    uType = 'HM2';
  }
  // console.log('uType: ' + uType);
  // if (match.path.includes('/p/')) {
  //   pageNumCh = true;
  //   pageNum = "pageNum" in match.params ? match.params.pageNum : 1;
  // }
  
  uType = uType.toUpperCase();
  let typeTitle = DlUnit.uTypeTitle(uType);

  useEffect(
    function() {
      if (groupSlug != '') {
        getGroupUtypeUnitLi({ dlGroupSlug: groupSlug, uType });
      } else {
        const dlUnitMaxPerPage = 50;
        getUnitLi({dlUnitCond: { uType }, dlUnitMaxPerPage});
      }
      typeTitle = DlUnit.uTypeTitle(uType);        
    },
    [uType]
  );

  let unitDispLi = [];

  for (let ind = 0; ind < dlUnitN.length; ind++) {
    const element = dlUnitN[ind];
    let item = new DlUnit();
    item.obSet(element);
    const unitDisp = ( groupSlug != '' ?
      <DlUnitCat item={item} catInd={ind + 1} key={"unit_cat_" + ind} /> :
      <DlUnitEl key={ind} item={item} id={item.id} ind={ind} />
    );
    unitDispLi.push(unitDisp);
  }

  return (
    <Container
      sm={{ span: 12 }}
      md={{ span: 12 }}
      lg={{ span: 12 }}
      xl={{ span: 12 }}
      className="container-artist-data"
    >
      <Row>   
        <Col
          sm={{ span: 12 }}
          md={{ span: 11, offset: 1 }}
          lg={{ span: 12, offset: 0 }}
          xl={{ span: 12, offset: 0 }}
        >
          <div style={{ width: "100%" }}>
            <p> { typeTitle } </p>
            <DlUnitSearch />
            Ukupno: {dlUnitCount}
            <br />
            <DlUnitLiNav />
            <br />
            {unitDispLi}          
          </div>
        </Col>   
      </Row>
    </Container>
  );
};

const GUnitList = sidemenuFooterWrap(BooksListing);
export default connect(mapStateToProps, mapDispatchToProps)(GUnitList);
